import { render, staticRenderFns } from "./box.vue?vue&type=template&id=9ee8d7e8"
import script from "./box.vue?vue&type=script&lang=ts"
export * from "./box.vue?vue&type=script&lang=ts"
import style0 from "./box.vue?vue&type=style&index=0&id=9ee8d7e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports